import ApiService from './ApiService';

export default class NewsApi extends ApiService {
    constructor() {
        super('');
    }

    // #region CMS
    getNews(payload) {
        return this.get('system/newsletter', payload);
    }

    createNews(payload) {
        return this.post('system/newsletter', payload);
    }

    getNewsId(newsId) {
        return this.get(`system/newsletter/${newsId}`);
    }

    updateNews(data) {
        const { newsId, payload } = data;
        return this.put(`system/newsletter/${newsId}`, payload);
    }

    deleteNews(newsId) {
        return this.delete(`system/newsletter/${newsId}`);
    }
    // #endregion

    // #region End User
    getNewsForEnduser(payload) {
        return this.get('newsletter', payload);
    }

    getNewsDetailForEnduser(data) {
        const { id, payload } = data;
        return this.get(`newsletter/${id}`, payload);
    }

    getNewHomes(payload) {
        return this.get('newsletter', payload);
    }
}
